// #region Imports

import chroma from 'chroma-js';

// #endregion

/**
 * Generates split-complementary colors based on the given base color.
 * Split-complementary uses two colors adjacent to the complement (150° and 210°).
 *
 * @param baseHex - The base color in hex format.
 * @returns An array of two split-complementary colors.
 * @public
 */
export function generateSplitComplementaryColors(baseHex: string): [string, string] {
    const [h, s, l] = chroma(baseHex).hsl();
    const splitH1 = (h + 150) % 360;
    const splitH2 = (h + 210) % 360;

    return [
        chroma.hsl(splitH1, s, l).hex(),
        chroma.hsl(splitH2, s, l).hex()
    ];
}

/**
 * Generates the first split-complementary color (150° from base).
 *
 * @param baseHex - The base color in hex format.
 * @returns The first split-complementary color.
 * @public
 */
export function generateSplitComplementaryColor1(baseHex: string): string {
    const [h, s, l] = chroma(baseHex).hsl();
    const splitH = (h + 150) % 360;

    return chroma.hsl(splitH, s, l).hex();
}

/**
 * Generates the second split-complementary color (210° from base).
 *
 * @param baseHex - The base color in hex format.
 * @returns The second split-complementary color.
 * @public
 */
export function generateSplitComplementaryColor2(baseHex: string): string {
    const [h, s, l] = chroma(baseHex).hsl();
    const splitH = (h + 210) % 360;

    return chroma.hsl(splitH, s, l).hex();
}
